export default __webpack_public_path__ + "static/media/c4.8b17faba.png";